// extracted by mini-css-extract-plugin
export default {"timestampLine":"src-signer-app-signature-request-display-field-signature-components-timestamp-line-module__timestampLine--AfvX2"};